import { ref } from 'vue'

export const visible = ref(false)

export const openClientelServe = () => {
    visible.value = true
}

export const closeClientelServe = () => {
    visible.value = false
}